import verifiedIcon from "../images/verified-icon.svg";
import "./Styles/verified.css";

const VerifiedBadge = () => {
    return (
        <img
            src={verifiedIcon}
            alt="Verified"
            className="verified-badge"
            style={{ width: '16px', height: '16px' }}
        />
    );
};

export default VerifiedBadge;
